// extracted by mini-css-extract-plugin
export default {"cls1":"FilterForm-Header_cls1__E89Gu","cls2":"FilterForm-Header_cls2__UCmA7 FilterForm-Header_cls1__E89Gu"};